export default "__VITE_ASSET__aca6902a__"